import React from 'react';

/**
 * MetricDisplay - Helper component for displaying a metric with label and unit
 */
export function MetricDisplay({ label, value, unit, muted = false }) {
  const textColor = muted ? 'text-muted' : 'text-white';
  const valueStr = value != null ? value.toFixed(value % 1 === 0 ? 0 : 1) : '--';

  return (
    <div>
      <div className="text-muted text-xs mb-1">{label}</div>
      <div className={`font-semibold ${textColor}`}>
        {valueStr}
        {unit && <span className="text-xs ml-1 opacity-70">{unit}</span>}
      </div>
    </div>
  );
}
